export default __webpack_public_path__ + "static/media/thum_3.c85a40f8.png";